import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from 'react';
import OutlinedEllipsisSquare from "acud-icon/es/icons/OutlinedEllipsisSquare";
import Popover from '../popover';
export default (function (props) {
  var prefixCls = props.prefixCls,
    popoverContent = props.popoverContent,
    popoverZIndex = props.popoverZIndex;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    popVisible = _useState2[0],
    setPopVisible = _useState2[1];
  var handleVisibleChange = function handleVisibleChange(visible) {
    setPopVisible(visible);
  };
  return /*#__PURE__*/React.createElement(Popover, {
    trigger: "click",
    placement: "rightBottom",
    zIndex: popoverZIndex === undefined ? 1051 : popoverZIndex,
    visible: popVisible,
    content: /*#__PURE__*/React.createElement("ul", {
      className: "".concat(prefixCls, "-popover-util"),
      onClick: function onClick() {
        return setPopVisible(false);
      }
    }, popoverContent),
    onVisibleChange: handleVisibleChange
  }, /*#__PURE__*/React.createElement(OutlinedEllipsisSquare, null));
});